module.exports = __webpack_public_path__ + "static/media/arrow-down.b7f2510b.svg";